import React from 'react';
import RequestApprovalIcon from 'assets/images/MarginTool/Pay_Package/RequestApprovalIcon.svg';
import ResetIcon from 'assets/images/MarginTool/Pay_Package/ResetIcon.svg';
import ApproveIcon from 'assets/images/MarginTool/Pay_Package/ApproveIcon.svg';
import VerifyIcon from 'assets/images/MarginTool/Pay_Package/VerifyIcon.svg';
import i18next from 'i18next';
import { theme } from 'styles/global-styles';
import {
  PlacementMarginPayPackageStatus,
  PlacementMarginStatusTransitionButtons,
} from 'store/redux-store/margin-tool/slices/placement/placement-pay-package-status/placement-pay-package-status.model';
import { IPlacementMarginDetailsResponseScenario } from 'store/redux-store/margin-tool/slices/placement/placement-add-edit-scenario/add-edit-placement-scenario.model';
import moment from 'moment-timezone';

export const getPayPackageStatusTooltip = (
  val: number,
  scenarioHeaderDetails: IPlacementMarginDetailsResponseScenario,
) => {
  if (val === PlacementMarginPayPackageStatus.Approved) {
    return (
      <span
        style={{
          font: 'normal normal normal 12px/20px Roboto',
          letterSpacing: '0px',
          color: theme.palette.system.doveGray,
          opacity: '1',
        }}
      >
        <ul>
          <li>
            {i18next.t('marginTool.payPackageStatus.headerButtonStatus.approvedBy', {
              approvedByName: `${scenarioHeaderDetails?.approvedUserFirst} ${scenarioHeaderDetails?.approvedUserLast}`,
            })}
          </li>
          <li>
            {i18next.t('marginTool.payPackageStatus.headerButtonStatus.approvedOn', {
              approvedOn: `${moment
                .tz(scenarioHeaderDetails?.approvedDateAt, 'UTC')
                .tz('America/Los_Angeles')
                .format('L hh:mm A')}`,
            })}
          </li>
        </ul>
      </span>
    );
  } else if (val === PlacementMarginPayPackageStatus.Verified) {
    return (
      <span
        style={{
          font: 'normal normal normal 12px/20px Roboto',
          letterSpacing: '0px',
          color: theme.palette.system.doveGray,
          opacity: '1',
        }}
      >
        <ul>
          <li>
            {i18next.t('marginTool.payPackageStatus.headerButtonStatus.verifiedBy', {
              verifiedByName: `${scenarioHeaderDetails?.verifiedUserFirst} ${scenarioHeaderDetails?.verifiedUserLast}`,
            })}
          </li>
          <li>
            {i18next.t('marginTool.payPackageStatus.headerButtonStatus.verifiedOn', {
              verifiedOn: `${moment
                .tz(scenarioHeaderDetails?.verifiedDateAt, 'UTC')
                .tz('America/Los_Angeles')
                .format('L hh:mm A')}`,
            })}
          </li>
        </ul>
        <ul>
          <li>
            {i18next.t('marginTool.payPackageStatus.headerButtonStatus.approvedBy', {
              approvedByName: `${scenarioHeaderDetails?.approvedUserFirst} ${scenarioHeaderDetails?.approvedUserLast}`,
            })}
          </li>
          <li>
            {i18next.t('marginTool.payPackageStatus.headerButtonStatus.approvedOn', {
              approvedOn: `${moment
                .tz(scenarioHeaderDetails?.approvedDateAt, 'UTC')
                .tz('America/Los_Angeles')
                .format('L hh:mm A')}`,
            })}
          </li>
        </ul>
      </span>
    );
  } else {
    return '';
  }
};

export const fetchStatusIcon = (
  button: PlacementMarginStatusTransitionButtons,
  enabled: boolean,
  isIconHovered: {
    buttonName?: PlacementMarginStatusTransitionButtons;
    isHovered: boolean;
  },
  isValid?: boolean,
) => {
  switch (button) {
    case PlacementMarginStatusTransitionButtons.Approve:
      return (
        <img
          src={ApproveIcon}
          alt="Approve Icon"
          style={{
            opacity: !enabled ? 0.5 : 1,
            pointerEvents: !enabled ? 'none' : 'auto',
            filter:
              isIconHovered?.buttonName === PlacementMarginStatusTransitionButtons.Approve && isIconHovered?.isHovered
                ? 'brightness(0) saturate(100%) invert(45%) sepia(95%) saturate(750%) hue-rotate(182deg) brightness(91%) contrast(91%)'
                : 'brightness(1) saturate(100%)',
            transition: 'filter 0.3s',
          }}
        />
      );
    case PlacementMarginStatusTransitionButtons.RequestApproval:
      return (
        <img
          src={RequestApprovalIcon}
          alt="Request Approval Icon"
          style={{
            opacity: !isValid ? 0.5 : 1,
            pointerEvents: !isValid ? 'none' : 'auto',
            filter:
              isIconHovered?.buttonName === PlacementMarginStatusTransitionButtons.RequestApproval &&
              isIconHovered?.isHovered
                ? 'brightness(0) saturate(100%) invert(45%) sepia(95%) saturate(750%) hue-rotate(182deg) brightness(96%) contrast(85%)'
                : 'brightness(1) saturate(100%)',
            transition: 'filter 0.3s',
          }}
        />
      );
    case PlacementMarginStatusTransitionButtons.reset:
      return (
        <img
          src={ResetIcon}
          alt="Reset Icon"
          style={{
            opacity: !enabled ? 0.5 : 1,
            pointerEvents: !enabled ? 'none' : 'auto',
            filter:
              isIconHovered?.buttonName === PlacementMarginStatusTransitionButtons.reset && isIconHovered?.isHovered
                ? 'brightness(0) saturate(100%) invert(45%) sepia(95%) saturate(750%) hue-rotate(182deg) brightness(91%) contrast(91%)'
                : 'brightness(1) saturate(100%)',
            transition: 'filter 0.3s',
          }}
        />
      );
    case PlacementMarginStatusTransitionButtons.verify:
      return (
        <img
          src={VerifyIcon}
          alt="Verify Icon"
          style={{
            opacity: !enabled ? 0.5 : 1,
            pointerEvents: !enabled ? 'none' : 'auto',
            filter:
              isIconHovered?.buttonName === PlacementMarginStatusTransitionButtons.verify && isIconHovered?.isHovered
                ? 'brightness(0) saturate(100%) invert(45%) sepia(95%) saturate(750%) hue-rotate(182deg) brightness(91%) contrast(91%)'
                : 'brightness(1) saturate(100%)',
            transition: 'filter 0.3s',
          }}
        />
      );
    default:
      return <></>;
  }
};

export const getStatusUpdateButtonDisabledTooltip = () => {
  return (
    <span
      style={{
        display: 'flex',
        flexDirection: 'column',
        font: 'normal normal normal 12px/20px Roboto',
        letterSpacing: '0px',
        color: theme.palette.system.doveGray,
        opacity: '1',
      }}
    >
      <span>{`${i18next.t('marginTool.tooltip.statusButtonDisabledTooltipHeader')} ${i18next.t(
        'marginTool.tooltip.roleBasedAccessRestriction',
      )}`}</span>
    </span>
  );
};

export enum EmailVariant {
  Internal = 'Internal',
  Candidate = 'Candidate',
}

export const getEmailTypeList = () => {
  return [
    {
      id: 1,
      name: i18next.t('marginTool.payPackageStatus.emailModal.emailCandidate'),
      type: EmailVariant.Candidate,
    },
    {
      id: 2,
      name: i18next.t('marginTool.payPackageStatus.emailModal.emailInternal'),
      type: EmailVariant.Internal,
    },
  ];
};

export enum MarginTemplateTitle {
  ApprovalProcess = 'Approval Process',
  CandidatePayQuote = 'Candidate Pay Quote',
}
